"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SelectItem", {
    enumerable: true,
    get: function() {
        return SelectItem;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../contexts/Theme");
const _FormCheckbox = require("../Form/FormCheckbox/FormCheckbox");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const SelectItem = (param)=>{
    let { noMargin = false, selected = false, indeterminate = false, label, className, onChange, disabled, itemSuffix, onClickContainer, role } = param;
    const { spacers, colors, borderRadius } = (0, _Theme.useTheme)();
    const ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ _react.default.createElement("div", {
        role: role !== null && role !== void 0 ? role : "option",
        ref: ref,
        onClick: (e)=>{
            if (e.target === ref.current) {
                onClickContainer === null || onClickContainer === void 0 ? void 0 : onClickContainer(e);
            }
        },
        className: _style.default.dynamic([
            [
                "b7d97e0d626be2d3",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    spacers.s1,
                    selected ? colors.lightHover : "none",
                    selected ? colors.lightHover : colors.grayscale_5
                ]
            ]
        ]) + " " + (className || "")
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "b7d97e0d626be2d3",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    spacers.s1,
                    selected ? colors.lightHover : "none",
                    selected ? colors.lightHover : colors.grayscale_5
                ]
            ]
        ]) + " " + "text"
    }, /*#__PURE__*/ _react.default.createElement(_FormCheckbox.FormCheckbox, {
        disabled: disabled,
        label: label,
        checked: selected,
        indeterminate: indeterminate,
        onChange: onChange
    })), itemSuffix, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "b7d97e0d626be2d3",
        dynamic: [
            spacers.s3,
            borderRadius,
            noMargin ? "none" : "0 ".concat(spacers.s3),
            spacers.s1,
            selected ? colors.lightHover : "none",
            selected ? colors.lightHover : colors.grayscale_5
        ]
    }, "div.__jsx-style-dynamic-selector{padding:".concat(spacers.s3, ";cursor:pointer;text-align:left;-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";margin:").concat(noMargin ? "none" : "0 ".concat(spacers.s3), ";font-weight:400;font-size:14px;line-height:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:").concat(spacers.s1, ";background:").concat(selected ? colors.lightHover : "none", ";white-space:nowrap}.text.__jsx-style-dynamic-selector{overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}div.__jsx-style-dynamic-selector:hover,div.__jsx-style-dynamic-selector:focus{background:").concat(selected ? colors.lightHover : colors.grayscale_5, "}div.__jsx-style-dynamic-selector:focus{outline:none}")));
};

//# sourceMappingURL=SelectItem.js.map